import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { AuthGuard } from './core/auth/auth.guard';
import { LayoutComponent } from './layouts/layout/layout.component';
import { NotFoundComponent } from './pages/pages/not-found/not-found.component';
// import { ResolvesResolver } from './core/auth/resolves.resolver';

export const appRoutes: VexRoutes = [
  { path: '', redirectTo: 'inicio-sesion', pathMatch: 'full' },
  {
    path: 'inicio-sesion',
    loadComponent: () =>
      import('./pages/pages/auth/login/login.component').then(
        (m) => m.LoginComponent
      )
  },
  {
    path: 'forgot-pass',
    loadComponent: () =>
      import('./pages/pages/auth/forgot-pass/forgot-pass.component').then(
        (m) => m.ForgotPassComponent
      )
  },
  {
    path: 'recuperar-contraseña',
    loadComponent: () =>
      import('./pages/pages/auth/restartpass/restartpass.component').then(
        (m) => m.RegisterComponent
      )
  },
  {
    path: 'home',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dash', pathMatch: 'full' },
      {
        path: 'dash',
        loadComponent: () =>
          import(
            './pages/home/dashboard-analytics/dashboard-analytics.component'
          ).then((m) => m.DashboardAnalyticsComponent),
        canActivate: [AuthGuard],
        data: { id_modulo: 1, id_vista: 1 }
      },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] }
    ]
  },
  {
    path: 'personas',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'contactos',
        loadComponent: () =>
          import('./pages/personas/gestion/gestion.component').then(
            (m) => m.GestionComponent
          ),
        canActivate: [AuthGuard],
        data: { id_modulo: 2, id_vista: 2 }
      },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] }
    ]
  },
  {
    path: 'procesos',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // {
      //   path: 'encuestas',
      //   loadComponent: () =>
      //     import('./pages/processes/surveys/surveys.component').then(
      //       (m) => m.SurveysComponent
      //     ),
      //   canActivate: [AuthGuard],
      //   data: { id_modulo: 3, id_vista: 34 }
      // },
      {
        path: 'contactabilidad',
        loadComponent: () =>
          import(
            './pages/processes/contactability/contactability.component'
          ).then((m) => m.ContactabilityComponent),
        canActivate: [AuthGuard],
        data: { id_modulo: 3, id_vista: 33 }
      },
      {
        path: 'noticias',
        loadComponent: () =>
          import('./pages/processes/news-layouts/news-layouts.component').then(
            (m) => m.NewsLayoutsComponent
          ),
        canActivate: [AuthGuard],
        data: { id_modulo: 3, id_vista: 36 }
      },
      {
        path: 'propuestas',
        loadComponent: () =>
          import('./pages/processes/proposals/proposals.component').then(
            (m) => m.ProposalsComponent
          ),
        canActivate: [AuthGuard],
        data: { id_modulo: 3, id_vista: 37 }
      },
      {
        path: 'marketing',
        loadComponent: () =>
          import('./pages/processes/marketing/marketing.component').then(
            (m) => m.MarketingComponent
          ),
        canActivate: [AuthGuard],
        data: { id_modulo: 3, id_vista: 35 }
      },
      {
        path: 'descartados',
        loadComponent: () => 
          import('./pages/processes/rejected/rejected.component').then(
            (m) => m.RejectedComponent
        ),
        canActivate: [AuthGuard],
        data: { id_modulo: 3, id_vista: 47 }
      },
      {
        path: 'tareas',
        loadComponent: () =>
          import('./pages/processes/tasks/tasks.component').then(
            (m) => m.TasksComponent
          ),
        canActivate: [AuthGuard],
        data: { id_modulo: 3, id_vista: 48 }
      },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] }
    ]
  },
  {
    path: 'ia',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'chat',
        loadChildren: () => import('./pages/ia/asisstants/chat/chat.routes'),
        canActivate: [AuthGuard]
      },
      {
        path: 'assistants',
        loadComponent: () =>
          import(
            './pages/ia/asisstants/assistants-grid/assistants-grid.component'
          ).then((m) => m.assistantComponent),
        canActivate: [AuthGuard],
        data: { id_modulo: 10, id_vista: 46 }
      },
      {
        path: 'assistant',
        loadComponent: () =>
          import('./pages/ia/asisstants/asisstants.component').then(
            (m) => m.AsisstantsComponent
          )
      },
      {
        path: 'agent-chat',
        loadComponent: () =>
          import('./pages/ia/asisstants/agent-chat/agent-chat.component').then(
            (m) => m.AgentChatComponent
          )
      },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] }
    ]
  },
  {
    path: 'opciones',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'soporte',
        loadChildren: () => import('./pages/options/support/support.routes'),
        canActivate: [AuthGuard],
        data: { id_modulo: 6, id_vista: 16 }
      },
      {
        path: 'mesa-ayuda',
        loadComponent: () =>
          import('./pages/options/help-desk/help-desk.component').then(
            (m) => m.HelpDeskComponent
          ),
        canActivate: [AuthGuard],
        data: { id_modulo: 6, id_vista: 15 }
      },
      {
        path: 'administracion',
        loadChildren: () => import('./pages/options/admin/admin.routes'),
        canActivate: [AuthGuard],
        data: { id_modulo: 6, id_vista: 18 }
      },
      {
        path: 'estadisticas',
        loadChildren: () => import('./pages/options/statistics/statistics.routes'),
        canActivate: [AuthGuard],
        data: { id_modulo: 6, id_vista: 39 }
      },
      /* {path: 'comunicacion-wp', loadChildren: () => import('./pages/options/ws-comunication/ws-comunication.routes'), canActivate: [AuthGuard],
        data: { id_modulo: 6, id_vista: 17 }
      }, */
      {
        path: 'perfilador',
        loadComponent: () =>
          import(
            './pages/options/admin/profiling/profiling-table/profiling-data-table/profiling-data-table.component'
          ).then((m) => m.ProfilingDataTableComponent),
        canActivate: [AuthGuard],
        data: { id_modulo: 6, id_vista: 43 }
      },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] }
    ]
  },
  {
    path: 'options-user',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'profile',
        loadChildren: () =>
          import('./pages/options-user/profile/profile.routes'),
        canActivate: [AuthGuard],
        data: { id_modulo: 7, id_vista: 19 }
      },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] }
    ]
  },

  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not-found' }
];
